exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader .el-upload[data-v-65e39793] {\n  border-radius: 0.03125rem;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  border: 0.005208rem dashed #ddd;\n}\n.avatar-uploader .el-upload[data-v-65e39793]:hover {\n  border-color: #409eff;\n}\n.avatar-uploader .el-upload:hover .avatar-uploader-icon[data-v-65e39793] {\n  color: #409eff;\n}\n.avatar-uploader-icon[data-v-65e39793] {\n  font-size: 0.145833rem;\n  color: #8c939d;\n  line-height: 0.927083rem;\n  text-align: center;\n  transition: all 0.2s linear;\n}\n.avatar[data-v-65e39793] {\n  display: block;\n  width: 1.5625rem;\n  height: 0.9375rem;\n}", ""]);

// exports
